/**
 * The element classes and record tables of contracts v2 (RFC 0002 §1.1; `orthos_model::DraftClass` and
 * `RecordTable`). Each class names the engine's tag for its kind, which is the `type` of the element's geometry.
 */

/** The element classes of the engine's 31 kinds and `draft.proxy`, with each kind's tag (`geometry.type`). */
export const DRAFT_CLASSES = [
  "draft.line",
  "draft.point",
  "draft.circle",
  "draft.arc",
  "draft.ellipse",
  "draft.polyline",
  "draft.polyline3d",
  "draft.spline",
  "draft.helix",
  "draft.ray",
  "draft.xline",
  "anno.text",
  "anno.mtext",
  "draft.attribute_definition",
  "draft.block_reference",
  "anno.dimension",
  "draft.multiline",
  "anno.leader",
  "anno.multileader",
  "anno.hatch",
  "draft.solid",
  "draft.trace",
  "draft.face3d",
  "draft.polyface_mesh",
  "draft.region",
  "sheet.viewport",
  "draft.image_reference",
  "draft.pdf_underlay",
  "draft.wipeout",
  "anno.table",
  "anno.tolerance",
  "draft.proxy",
] as const;
export type DraftClass = (typeof DRAFT_CLASSES)[number];

export const DRAFT_KINDS: Readonly<Record<DraftClass, string>> = {
  "draft.line": "line",
  "draft.point": "point",
  "draft.circle": "circle",
  "draft.arc": "arc",
  "draft.ellipse": "ellipse",
  "draft.polyline": "lwPolyline",
  "draft.polyline3d": "polyline3d",
  "draft.spline": "spline",
  "draft.helix": "helix",
  "draft.ray": "ray",
  "draft.xline": "xLine",
  "anno.text": "text",
  "anno.mtext": "mText",
  "draft.attribute_definition": "attDef",
  "draft.block_reference": "insert",
  "anno.dimension": "dimension",
  "draft.multiline": "mLine",
  "anno.leader": "leader",
  "anno.multileader": "mLeader",
  "anno.hatch": "hatch",
  "draft.solid": "solid",
  "draft.trace": "trace",
  "draft.face3d": "face3d",
  "draft.polyface_mesh": "polyfaceMesh",
  "draft.region": "region",
  "sheet.viewport": "viewport",
  "draft.image_reference": "image",
  "draft.pdf_underlay": "underlay",
  "draft.wipeout": "wipeout",
  "anno.table": "table",
  "anno.tolerance": "tolerance",
  "draft.proxy": "unknown",
};

/** A drawing's tables, named after the engine's `Drawing` fields (RFC 0002 §1.1). */
export const RECORD_TABLES = [
  "layer",
  "linetype",
  "textStyle",
  "dimStyle",
  "mleaderStyle",
  "tableStyle",
  "mlineStyle",
  "block",
  "layout",
  "view",
  "vport",
  "ucs",
  "layerState",
  "group",
  "plotStyleTable",
  "constraint",
  "parameter",
  "scale",
  "parametricSettings",
  "foreign",
] as const;
export type RecordTable = (typeof RECORD_TABLES)[number];
